module.exports = __webpack_public_path__ + "static/media/logo-small.8704a25f.png";